import ProductCounter from './product-counter';


export default ProductCounter;